import { render } from "./OrderCorpCard.vue?vue&type=template&id=048f2737"
import script from "./OrderCorpCard.vue?vue&type=script&lang=js"
export * from "./OrderCorpCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__